import { CircularProgress } from "@mui/material";
import React from "react";

export default function CodeLoading() {
    return(
        <div style={{width: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
            <CircularProgress color="primary" />
        </div>
    )
  }